import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css!';

class SliderRubrique {

  constructor(){
    this.components = document.querySelectorAll('[data-trigger="slider-rubrique"]');
    this._init();
  }

  _init(){

    if( this.components ){
      for (let component of this.components) {
        let swiper = null;
        const slideNumber = component.querySelectorAll('.slider-rubrique__slide').length;
          
        const firstImage = component.querySelector('img');
        if(firstImage){
          firstImage.onload = ()=> {
            if(swiper){
              swiper.update();
            }
          };
        }

        swiper = new Swiper(component, {
          navigation: {
            nextEl: component.querySelector('[data-trigger="slider-rubrique-next"]'),
            prevEl: component.querySelector('[data-trigger="slider-rubrique-prev"]'),
          },
          pagination: {
            el: component.querySelector('[data-trigger="slider-rubrique-pagination"]'),
            type: 'bullets',
            clickable: true
          },
          speed: 400,
          autoplay        : {
            delay: 5000,
          },
          loop            : true,
          preloadImages: false,
          lazy: {
            loadOnTransitionStart: true,
          }
        });

        if (slideNumber === 1) {
          swiper.autoplay.stop();
        }

      }
    }
  }

}

export const sliderRubrique = new SliderRubrique();